import { UnauthenticationHandlerComponent } from './components/authentication/unauthentication-handler.component';
import { AuthGuard } from './services/auth.guard';
import { PolicyComponent } from './component/policy/policy.component';
import { SearchComponent } from './component/search/search.component';
import { SearchResultsComponent } from './component/search-results/search-results.component';
import { LoginComponent } from './component/Login/login.component';
import { OverviewComponent } from './component/overview/overview.component';
import { LandingComponent } from './component/landing/landing.component';
import { PolicyquotesComponent } from './component/policyQuotes/policyQuotes.component';
import { CancelPolicyPopUp } from './component/policy/cancel-policy-popup/cancel-policy-popup.component';
import { EvidenceOfInsuranceComponent } from './component/policy/evidence-of-insurance/evidence-of-insurance.component';
import { ReportClaimComponent } from './component/policy/report-claim/report-claim.component';
import { MaintenanceComponent } from './component/maintenance/maintenance.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {

    path: 'xps/unauthenticated',
    component: UnauthenticationHandlerComponent,
  },
  { path: '', redirectTo: 'xps/landing', pathMatch: 'full'},
  {
    path: 'xps/landing',
    canActivate: [AuthGuard], component: LandingComponent
  },
  {  path: 'xps/policy', component: PolicyComponent, canActivate: [AuthGuard] },
  { path: 'xps/search', component: SearchComponent },
  { path: 'xps/search-results', component: SearchResultsComponent },
  { path: 'xps/login', component: LoginComponent },
  { path: 'xps/overview', component: OverviewComponent },
  { path: 'xps/landing', component: LandingComponent},
  { path: 'xps/policyQuotes',component: PolicyquotesComponent },
  { path: 'xps/evidenceofinsurance',component: EvidenceOfInsuranceComponent },
  { path: 'xps/cancelmypolicy', component:CancelPolicyPopUp },
  { path: 'xps/reportclaim', component:ReportClaimComponent },
  { path: 'xps/maintenance', component:MaintenanceComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
